import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CakeSlice, Home, Search, UtensilsCrossed } from "lucide-react";

import SystemPageShell from "./SystemPageShell";

export default function NotFoundPage() {
  useEffect(() => { document.title = "Page Not Found | SugaLumps"; }, []);
  return (
    <SystemPageShell
      eyebrow="404"
      title="Oops — this treat went missing."
      copy="The page you're looking for may have been moved, removed, or never made it out of the oven."
      icon={<CakeSlice size={38} strokeWidth={1.5} />}
      actions={(
        <>
          <Link className="sl-system-button primary" to="/"><Home size={16} /> Back Home</Link>
          <Link className="sl-system-button secondary" to="/menu"><UtensilsCrossed size={16} /> Browse the Menu</Link>
        </>
      )}
    >
      <p className="sl-system-note"><Search size={14} aria-hidden="true" /> Nothing to see here except a very determined crumb trail.</p>
    </SystemPageShell>
  );
}
